import { TaskType } from '../task.model';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TaskExecution } from '../task-processing.model';
import { AppServerAPI, DialogService, DocumentDialogComponent } from '@sdbn/common';
import { HttpHeaders } from '@angular/common/http';
import { PictureSeriesTaskDialogComponent } from '../picture-series-task-dialog/picture-series-task-dialog.component';

@Component({
  selector: 'app-task-execution',
  templateUrl: './task-execution.component.html',
  styleUrls: ['./task-execution.component.scss']
})
export class TaskExecutionComponent {

  TaskType = TaskType;

  iconClass = 'fa-people';

  taskExecution: TaskExecution;

  requestRunning = false;

  @Input() maxFileSize: number = 10

  @Input('taskExecution') set setTaskExecution(value: TaskExecution) {
    this.taskExecution = value;
    this.updateIcon();
  }

  @Input() metaData: any;

  @Output() changed = new EventEmitter<null>();

  constructor(
    private dialogService: DialogService,
    private appServerAPI: AppServerAPI
  ) { }

  private updateIcon() {
    switch (this.taskExecution?.task?.type) {
      case TaskType.CHECK:
        this.iconClass = 'fa-shield-check';
        break;
      case TaskType.DOCUMENT:
        this.iconClass = 'fa-file';
        break;
      case TaskType.PICTURE:
        this.iconClass = 'fa-camera';
        break;
      case TaskType.PICTURE_SERIES:
        this.iconClass = 'fa-images';
        break;
      case TaskType.MESSAGE:
        this.iconClass = 'fa-message';
        break;
      default:
        this.iconClass = '';
    }
  }

  public onClick() {

    switch (this.taskExecution?.task?.type) {
      case TaskType.CHECK:
        this.completeCheck();
        break;
      case TaskType.DOCUMENT:
        this.processDocument()
        break;
      case TaskType.PICTURE:
        console.error('unexcpected case');
        break;
      case TaskType.PICTURE_SERIES:
        this.processPictureSeries();
        break;
      case TaskType.MESSAGE:
        this.completeMessage();
        break;
    }
  }

  private completeCheck() {

    this.appServerAPI.execute('/tmc-common/processing/task-execution/completeCheckTask', { taskId: this.taskExecution.task?.id, source: this.taskExecution.source, sourceId: this.taskExecution.sourceId }).subscribe(response => {
      this.changed.emit();
    });

  }

  private processDocument() {

    this.dialogService.openMaxHeight(DocumentDialogComponent, {
      // documentIds: this.taskExecution.task.documentIds,
      documentTemplateId: this.taskExecution.task.documentTemplate?.id,
      // transportId: this.transportId,
      addDocumentsEnabled: true
    }).afterClosed().subscribe(result => {

      this.appServerAPI.execute('/tmc-common/processing/task-execution/completeDocumentTask', null).subscribe(response => {
        this.changed.emit();
      });

    });

  }

  private processPictureSeries() {
    this.dialogService.openMaxHeight(PictureSeriesTaskDialogComponent, {}).afterClosed().subscribe(result => {
      if (result) {
        // this.task.resourceIds = result;
        // this.completeTask();
      }
    });
  }


  private completeMessage() {

    this.appServerAPI.execute('/tmc-common/processing/task-execution/completeMessageTask', null).subscribe(response => {
      this.changed.emit();
    });

  }

  public handleFileEvent(event: Event) {
    console.log('new file event', event);

    const files = (event.target as HTMLInputElement).files;
    if (files != null) {
      for (let i = 0; i < files.length; i++) {
        const current: File = files.item(i);
        const name = current.name;
        const type = current.type;

        if (current.size > this.maxFileSize * 1024 * 1024) {
          this.dialogService.showInfoDialog(
            'tmc.transport-details.dialog.invalid-file-size.title',
            'tmc.transport-details.dialog.invalid-file-size.message');
          return;
        }

        const reader = new FileReader();
        reader.onload = () => {
          this.uploadFile(type, name, reader.result);
        };
        reader.readAsArrayBuffer(current);

      }
    } else {
      this.requestRunning = false;
    }
  }

  private uploadFile(type: string, fileName: string, content: any) {

    this.requestRunning = true;
    let header = new HttpHeaders({
      'Content-Type': type,
      'Content-MD5': 'not yet implemented',
      'usage': 'task-document',
      'filename': encodeURIComponent(fileName)
    });
    if (this.metaData != null) {
      header = header.append('fileMetaData', JSON.stringify(this.metaData));
    }

    return this.appServerAPI.postFile<any>('/app-client/resource/upload', content, header).toPromise().then(response => {

      // TODO Aufgabe erledigen??
      // this.changed.next(response.resourceId);
      this.appServerAPI.execute('/tmc-common/processing/task-execution/completePictureTask', null).subscribe(response => {
        this.changed.emit();
      });

      this.requestRunning = false;
    }, error => {
      this.requestRunning = false;
    });
  }

}
